import React, { useState } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../contexts/AuthContext';

const Login = () => {
  const { login, isAuthenticated, isApproved } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  if (isAuthenticated) {
    return <Navigate to={isApproved ? '/jobs' : '/onboarding'} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await login(email, password);
      const approved = data.data.user.onboarding_status === 'approved' || !data.data.user.onboarding_status;
      navigate(approved ? '/jobs' : '/onboarding');
    } catch (err) {
      toast.error(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <form onSubmit={submit} className="bg-white rounded-xl shadow-md w-full max-w-md p-8">
        <h1 className="text-2xl font-semibold text-teal-800">Vendor sign in</h1>
        <p className="text-slate-600 text-sm mt-1 mb-6">Access your jobs and onboarding</p>
        <label className="block text-sm font-medium mb-1">Email</label>
        <input
          type="email"
          className="w-full border rounded-lg px-3 py-2 mb-4"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <label className="block text-sm font-medium mb-1">Password</label>
        <input
          type="password"
          className="w-full border rounded-lg px-3 py-2 mb-6"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-teal-700 text-white py-2.5 rounded-lg hover:bg-teal-800 disabled:opacity-50"
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
        <p className="text-sm text-slate-600 mt-6 text-center">
          New cleaning partner?{' '}
          <Link to="/apply" className="text-teal-700 font-medium hover:underline">
            Start your application
          </Link>
        </p>
      </form>
    </div>
  );
};

export default Login;
